import { useEffect, useState } from "react";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Products from "@/components/Products";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Connectivity from "@/components/Connectivity";
import WhyChoose from "@/components/WhyChoose";
import Industries from "@/components/Industries";
import Capabilities from "@/components/Capabilities";
import Trust from "@/components/Trust";
import CtaSection from "@/components/CtaSection";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import QuoteModal from "@/components/QuoteModal";
import WhatsAppFloat from "@/components/WhatsAppFloat";

export default function Home() {
  const [quote, setQuote] = useState({ open: false, requirement: "" });
  const openQuote = (requirement = "") => setQuote({ open: true, requirement });

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-white text-slate-900" data-testid="home-page">
      <Navbar onQuote={openQuote} />
      <main>
        <Hero onQuote={openQuote} />
        <Marquee />
        <About />
        <Products onQuote={openQuote} />
        <Services />
        <Process onQuote={openQuote} />
        <Connectivity />
        <WhyChoose />
        <Industries />
        <Capabilities />
        <Trust />
        <CtaSection onQuote={openQuote} />
        <Contact />
      </main>
      <Footer />
      <QuoteModal state={quote} onClose={() => setQuote({ open: false, requirement: "" })} />
      <WhatsAppFloat />
    </div>
  );
}
